export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_BUSINESS_PARTNERS = 'businessPartners';
export const COLUMN_EMAIL = 'email';
export const COLUMN_LAST_ACTIVITY_DATE = 'lastActivityDate';
export const COLUMN_REG_DATE = 'regDate';
export const COLUMN_TEST = 'isTest';

export const STATUS_ACTIVE = 0;

// filter
export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_SHOW = 'showInactive';
